// Shared with cart-items.js (via window) so both interaction paths apply the exact same
// checkout-gating decision instead of each re-deriving it and risking drift. Scoped per
// [data-cart-footer] instance (via querySelectorAll, not querySelector/getElementById) in
// case this ever runs on a page with more than one on it (e.g. cart_type: modal).
function applyCartCheckoutButtonDisabledState() {
  document.querySelectorAll('[data-cart-footer]').forEach((cartFooter) => {
    const checkoutButton = cartFooter.querySelector(
      '.push-btn-surface-cart-checkout'
    );
    if (!checkoutButton) return;

    // Trust the server-computed decision (rosoły 3-6-9 rule + zupy minimum) instead of
    // re-deriving it here, so this never drifts out of sync with cart-footer.liquid.
    const bundleRuleDisabled = cartFooter.getAttribute('data-checkout-disabled') === 'true';

    // Terms checkbox is client-only state; the server always renders it unchecked.
    const agreementCheckbox = cartFooter.querySelector('[name="cart-agreement"]');
    const agreementChecked = agreementCheckbox ? agreementCheckbox.checked : true;

    const shouldDisable = bundleRuleDisabled || !agreementChecked;

    if (shouldDisable) {
      if (!checkoutButton.hasAttribute('disabled')) {
        checkoutButton.setAttribute('disabled', true);
      }
    } else {
      if (checkoutButton.hasAttribute('disabled')) {
        checkoutButton.removeAttribute('disabled');
      }
    }

    // Shopify's accelerated checkout buttons (Google Pay, Shop Pay...) render here and skip
    // /cart's own checkout button entirely, so they need the same gate applied separately.
    // Alpine.morph explicitly skips this element (see updating() below) to avoid breaking the
    // wallet web components' internal state, so its blocked state is only ever set from here.
    const dynamicCheckoutButtons = cartFooter.querySelector('.additional-checkout-buttons');
    if (dynamicCheckoutButtons) {
      dynamicCheckoutButtons.classList.toggle('additional-checkout-buttons--blocked', shouldDisable);
    }
  });
}
window.applyCartCheckoutButtonDisabledState = applyCartCheckoutButtonDisabledState;

document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_CartFooter', () => {
    return {
      footerRoot: null,
      _morphFooter(e) {
        const footerHtml = e.detail.response?.sections?.['cart-footer'];
        if (!footerHtml) return;

        const newFooterSection = querySelectorInHTMLString(
          '[data-cart-footer]',
          footerHtml
        );

        Alpine.morph(
          this.footerRoot,
          newFooterSection ? newFooterSection.outerHTML : '',
          {
            updating(el, toEl, childrenOnly, skip) {
              if (
                el.classList &&
                el.classList.contains('additional-checkout-buttons')
              ) {
                skip();
              }
            },
          }
        );

        // Update checkout button state after morphing
        this.$nextTick(() => {
          applyCartCheckoutButtonDisabledState();
        });
      },
      init() {
        this.footerRoot = this.$root;

        // Re-evaluate on load: the agreement checkbox always starts unchecked, so the
        // server-rendered button can only reflect the bundle rule, not the checkbox.
        applyCartCheckoutButtonDisabledState();

        document.addEventListener('change', (e) => {
          if (e.target && e.target.id === 'checkout' && e.target.type === 'checkbox') {
            applyCartCheckoutButtonDisabledState();
          }
        });

        window.addEventListener('shapes:modalcart:afteradditem', (e) => {
          this._morphFooter(e);
        });

        window.addEventListener('shapes:modalcart:cartqtychange', (e) => {
          this._morphFooter(e);
        });

        // Safety net: re-check periodically regardless of which event fired (or didn't).
        // Cart mutations can come from more than one path (qty stepper, discount code,
        // browser back/forward to a cached page...) and this guarantees the button state
        // never stays stuck stale for more than a moment, whatever the trigger was.
        setInterval(() => applyCartCheckoutButtonDisabledState(), 500);
      },
    };
  });
});
